import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import { getTranslation } from '../translations';
import './Footer.css';

const Footer = () => {
  const { language } = useLanguage();
  const { user } = useAuth();
  const t = (path) => getTranslation(language, path);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <h3>🏰 {language === 'en' ? 'Kshatriya Maunas Parivar' : 'क्षत्रिय मौनस परिवार'}</h3>
              <p>
                {language === 'en' 
                  ? 'Dedicated to preserving our rich heritage and empowering the Maunas Kshatriya community through unity, tradition, and progress.'
                  : 'हमारी समृद्ध विरासत को संरक्षित करने और मौनस क्षत्रिय वंश को शिक्षा, रोजगार एवं एकजुटता के माध्यम से सशक्त बनाने के लिए समर्पित।'}
              </p>
              <div className="social-icons">
                <a href="https://www.facebook.com/share/1Cga4q88Kf/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                <a href="https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.instagram.com%2Fkshatriya.maunaspariwar%3Ffbclid%3DIwZXh0bgNhZW0CMTAAYnJpZBExQjg2NFNUZTA0QzVEZHdKdnNydGMGYXBwX2lkEDIyMjAzOTE3ODgyMDA4OTIAAR5AL95QG_DmZSme1Zu0V81Tmss7jo80NVtdwqZw5J-KPt-LciLChCpxUrgfQg_aem_xu09SrLL3XtUPFHfYEf2nA&h=AT69s4wwiIsaho9wMvjC9vc56KppS6M3_vvJSRFyInOJDTa5jaiVxpBCcx_N66DfL_rIG_TgkQW2_OtwxD0pVSUfUjpak6F_mAdajvrsOri_2EnUgnpwXf6z2ei7iyJ2rPqx" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-section">
              <h4>{language === 'en' ? 'Quick Links' : 'त्वरित लिंक'}</h4>
              <ul>
                <li><Link to="/" onClick={scrollToTop}>{t('header.home')}</Link></li>
                <li><Link to="/about" onClick={scrollToTop}>{t('header.about')}</Link></li>
                <li><Link to="/community" onClick={scrollToTop}>{t('header.community')}</Link></li>
                <li><Link to="/heritage" onClick={scrollToTop}>{t('header.heritage')}</Link></li>
                {user && (
                  <>
                    <li><Link to="/gallery" onClick={scrollToTop}>{t('header.gallery')}</Link></li>
                  </>
                )}
              </ul>
            </div>

            <div className="footer-section">
              <h4>{language === 'en' ? 'Our Community' : 'हमारा समुदाय'}</h4>
              <ul>
                <li><Link to="/community?section=prakosth" onClick={scrollToTop}>{language === 'en' ? 'Our Cells (Prakosth)' : 'हमारा प्रकोष्ठ'}</Link></li>
                <li><Link to="/community?section=upadhi" onClick={scrollToTop}>{language === 'en' ? 'Upadhidhaarak' : 'उपाधिधारक'}</Link></li>
                <li><Link to="/community?section=members" onClick={scrollToTop}>{language === 'en' ? 'Our Members' : 'हमारे सदस्य'}</Link></li>
                <li><Link to="/about?committee=sanrakshak" onClick={scrollToTop}>{language === 'en' ? 'Protective Committee' : 'संरक्षक कमेटी'}</Link></li>
                <li><Link to="/about?committee=prabandhan" onClick={scrollToTop}>{language === 'en' ? 'Management Committee' : 'प्रबन्धन कमेटी'}</Link></li>
                <li><Link to="/about?committee=sanchalan" onClick={scrollToTop}>{language === 'en' ? 'Execution Committee' : 'संचालक कमेटी'}</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>{language === 'en' ? 'Get Involved' : 'शामिल हों'}</h4>
              <ul>
                <li><Link to="/membership" onClick={scrollToTop}>{language === 'en' ? 'Member Registration' : 'सदस्य पंजीकरण'}</Link></li>
                <li><Link to="/heritage" onClick={scrollToTop}>{language === 'en' ? 'Our Historical Heritage' : 'हमारे ऐतिहासिक धरोहर'}</Link></li>
                <li><Link to="/community?section=sahyogi" onClick={scrollToTop}>{language === 'en' ? 'Donate' : 'सहयोग करें'}</Link></li>
                <li><Link to="/contact" onClick={scrollToTop}>{t('header.contact')}</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>{language === 'en' ? 'Contact Information' : 'संपर्क जानकारी'}</h4>
              <div className="contact-details">
                <p className="contact-item">
                  <span className="contact-icon">📍</span>
                  <span>{language === 'en' ? 'Devtaayan, Surabhi Nagar Colony, Avleshpur, Varanasi' : 'देवतायन, सुरभि नगर कॉलोनी, अवलेशपुर वाराणसी'}</span>
                </p>
                <p className="contact-item">
                  <span className="contact-icon">📧</span>
                  <span>kshatriyamaunasparivar@gmail.com</span>
                </p>
                <p className="contact-item">
                  <span className="contact-icon">📞</span>
                  <span>+91 8840709296</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; 2024 {language === 'en' ? 'Kshatriya Maunas Parivar. All rights reserved.' : 'क्षत्रिय मौनस परिवार। सर्वाधिकार सुरक्षित।'}</p>
            <div className="footer-links">
              <Link to="/" onClick={scrollToTop}>{language === 'en' ? 'Privacy Policy' : 'गोपनीयता नीति'}</Link>
              <Link to="/" onClick={scrollToTop}>{language === 'en' ? 'Terms & Conditions' : 'शर्तें और शर्तें'}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
